<template>
    <div class="modal fade" :id="'createBrandModal_'+modalId" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <form @submit.prevent="submitData" class="form">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalId == "create" ? $t('brands.creation') : $t('brands.modification') }}</h5>
                        <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
                            <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                        fill="currentColor"/>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                        fill="currentColor"/>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <RequiredText />
                        <div class="d-flex flex-column mb-8 fv-row">
                            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                                <span class="required">{{$t('brands.name')}}</span>
                            </label>
                            <input type="text" class="form-control form-control-solid" v-model="formData.name" :placeholder="$t('brands.name_placeholder')" required />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <Button btn-class="btn-sm me-2" type="cancel" btn-text="button.close" size="7px 30px" @click="closeModal"/>
                        <Button btn-class="btn-sm" type="submit" btn-text="button.save" size="7px 30px" :isLoading="isLoadingBrand"/>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>

    import {ref, defineProps} from 'vue'
    import {useStore} from "vuex";
    import RequiredText from "@/components/RequiredText"
    import Button from "@/components/Button.vue"

    const store = useStore()

    const props = defineProps({
        brand: { 
            type: Object, 
            default: {
                name: ''
            } 
        },
        id: {
            type: String,
            required: true
        }
    })

    const emits = defineEmits(['load', 'addBrand'])

    const modalId = ref(props.id)

    const formData = ref(props.brand)
    const isLoadingBrand = ref(false)

    function submitData(){
        if(modalId.value == "create"){
            createBrandData()
        }else{
            updateBrandData()
        }
    }

    function closeModal(){
        $('#createBrandModal_'+modalId.value).modal('toggle')
    }

    function createBrandData() {
        isLoadingBrand.value = true
        store.dispatch('brands/createBrand', formData.value)
            .then((response) => {
                emits('addBrand', response.data?.brand?.id)
                emits('load')
                isLoadingBrand.value = false
                $('#createBrandModal_'+modalId.value).modal('toggle')
                formData.value.name = ''
                window.toastr['success'](i18n.global.t('notification.brand_created'))
            })
            .catch(err => {
                isLoadingBrand.value = false
            })
    }

    function updateBrandData() {
        isLoadingBrand.value = true
        store.dispatch('brands/updateBrand', formData.value)
            .then((response) => {
                emits('load')
                isLoadingBrand.value = false
                $('#createBrandModal_'+modalId.value).modal('toggle')
                formData.value.id = ''
                formData.value.name = ''
                window.toastr['success'](i18n.global.t('notification.brand_updated'))
            })
            .catch(err => {
                isLoadingBrand.value = false
            })
    }
</script>